import React, { useState } from "react";
import "./style.css";

import { COR_DEFAULT, CampoObrigatorio, handleValidaCampos } from "../../pages/PesquisaSatisfacao";

const LikerNota = ({ item, register, setValue, getValues }) => {
    const campo = `id_${item.codperguntaSatisfacao}`;
    const lista = Array.from({ length: 11 }, (value, index) => index);
    const [valor, setValor] = useState(-1);

    function handleItem(value) {
        setValue(campo, value);
        setValor(value);
        handleValidaCampos(getValues(), item);
    }

    return (
        <div className="pesquisa-satisfacao-item-container" key={item.codperguntaSatisfacao}>
            <CampoObrigatorio id={`div_${item.codperguntaSatisfacao}`} />

            <span className="pesquisa-satisfacao-item-texto">{item.texto}</span>
            <span className="pesquisa-satisfacao-item-hint">{item.hint}</span>

            <div className="liker-nota-content">
                {lista?.map((value, index, array) => {
                    return (
                        <div 
                            className="liker-nota-item-content" 
                            style={{
                                backgroundColor: valor === value ? COR_DEFAULT : null,
                                color: valor === value ? "#FFF" : "#000",
                            }} 
                            onClick={() => handleItem(value)}
                        >
                            <span 
                                className="liker-nota-item"
                                key={index} 
                            >
                                {value}
                            </span>
                        </div>
                    )
                })}
            </div>

            <input style={{display: "none"}} defaultValue={''} {...register(campo, { required: false })}></input>
        </div>
    )
}

export default LikerNota;